import { NgModule } from '@angular/core';
import { BlockableDivComponent } from './blockable-div.component';

@NgModule({
    declarations: [
        BlockableDivComponent,
    ],
    imports: [
    ],
    exports: [BlockableDivComponent]
})
export class BlockableDivModule { }
